import React, { Component, PropTypes } from 'react';

class CancelIcon extends Component {
  static propTypes = {
    color: PropTypes.string
  }

  static defaultProps = {
    color: '#000'
  }

  render() {
    const { color } = this.props;

    return (
      <svg className="CancelIcon" width="12px" height="12px" viewBox="0 0 24 24" xmlSpace="preserve">
          <g stroke="none" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <g stroke={color} strokeWidth="1.5" fill={color}>
                  <g transform="translate(2.500000, 2.500000)">
                      <path d="M18.6039289,18.9997581 C18.5025966,18.9997581 18.4012643,18.9609668 18.3236818,18.884176 L0.115538146,0.676032307 C-0.0388352461,0.520867257 -0.0388352461,0.270703196 0.115538146,0.115538146 C0.270703196,-0.0388352461 0.520867257,-0.0388352461 0.676032307,0.115538146 L18.884176,18.3236818 C19.0385494,18.4788469 19.0385494,18.7290109 18.884176,18.884176 C18.8065934,18.9609668 18.7052612,18.9997581 18.6039289,18.9997581"></path>
                      <path d="M0.395785227,18.9997581 C0.294452949,18.9997581 0.193120671,18.9609668 0.115538146,18.884176 C-0.0388352461,18.7290109 -0.0388352461,18.4788469 0.115538146,18.3236818 L18.3236818,0.115538146 C18.4788469,-0.0388352461 18.7290109,-0.0388352461 18.884176,0.115538146 C19.0385494,0.270703196 19.0385494,0.520867257 18.884176,0.676032307 L0.676032307,18.884176 C0.598449782,18.9609668 0.497117504,18.9997581 0.395785227,18.9997581"></path>
                  </g>
              </g>
          </g>
      </svg>
    );
  }
}

export default CancelIcon;



// WEBPACK FOOTER //
// ./app/components/icons/Cancel.js